import { all, call, put, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../constants/index';
import { request, setAuthToken, removeAuthToken } from '../modules/client';

export function* signup({ payload }) {
  try {
    const response = yield call(request, 'api/auth/signup', {
      payload: payload.credentials,
    });

    if (response.status === 'success') {
      const { token } = response.result;
      setAuthToken(token);
      yield put({
        type: ActionTypes.SESSION_SIGNUP_SUCCESS,
        payload: { token },
      });
    }
    else {
      yield put({
        type: ActionTypes.SESSION_SIGNUP_FAILURE,
        payload: response.result.errors,
      });
    }
  }
  catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.SESSION_SIGNUP_FAILURE,
      payload: [],
    });
  }
}

export function* login({ payload }) {
  try {
    const response = yield call(request, 'api/auth/login', {
      payload: payload.credentials,
    });

    if (response.status === 'success') {
      const { token, email } = response.result;
      setAuthToken(token);
      yield put({
        type: ActionTypes.SESSION_LOGIN_SUCCESS,
        payload: { token, email },
      });
    }
    else {
      removeAuthToken();
      yield put({
        type: ActionTypes.SESSION_LOGIN_FAILURE,
        payload: response.result.errors,
      });
    }
  }
  catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.SESSION_LOGIN_FAILURE,
      payload: [],
    });
  }
}


export function* forgotPassword({ payload }) {
  try {
    const response = yield call(request, 'api/auth/forgot', {
      payload: payload.credentials,
    });
    if (response.status === 'success') {
      yield put({
        type: ActionTypes.SESSION_FORGOT_SUCCESS,
      });
    }
    else {
      yield put({
        type: ActionTypes.SESSION_FORGOT_FAILURE,
        payload: response.result.errors,
      });
    }
  }
  catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.SESSION_FORGOT_FAILURE,
      payload: [],
    });
  }
}


export function* resetPassword({ payload }) {
  try {
    const response = yield call(request, 'api/auth/reset', {
      payload: payload.credentials,
    });
    if (response.status === 'success') {
      const { token } = response.result;
      setAuthToken(token);
      yield put({
        type: ActionTypes.SESSION_RESET_SUCCESS,
        payload: token,
      });
    }
    else {
      yield put({
        type: ActionTypes.SESSION_RESET_FAILURE,
        payload: response.result.errors,
      });
    }
  }
  catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.SESSION_RESET_FAILURE,
      payload: [],
    });
  }
}

export function* logout() {
  removeAuthToken();
  yield put({ type: ActionTypes.SESSION_LOGOUT_SUCCESS});
}

export function* registerFCMToken({ payload }) {
  try {
    const response = yield call(request, 'api/auth/registerFCMToken', {
      payload,
    });

    if (response.status === 'success') {
      yield put({ type: ActionTypes.SESSION_REGISTERFCM_SUCCESS });
    }
    else {
      yield put({
        type: ActionTypes.SESSION_REGISTERFCM_FAILURE,
        payload: response.result.errors,
      });
    }
  }
  catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.SESSION_REGISTERFCM_FAILURE,
      payload: [],
    });
  }
}

export function* oAuthLogin({ payload }) {
  console.log('oAuthInfo called', payload);

  try {
    const response = yield call(request, 'api/auth/oAuthLogin', {
      payload: payload.oAuthInfo,
    });

    if (response.status === 'success') {
      const { token } = response.result;
      setAuthToken(token);
      yield put({
        type: ActionTypes.SESSION_LOGIN_AUTH_CODE_SUCCESS,
        payload: { token },
      });
    }
    else {
      yield put({
        type: ActionTypes.SESSION_LOGIN_AUTH_CODE_FAILURE,
        payload: response.result.errors,
      });
    }
  }
  catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.SESSION_LOGIN_AUTH_CODE_FAILURE,
      payload: [],
    });
  }
}


export function* oAuthSignup({ payload }) {
  // console.log('oAuthSignup called');

  try {
    const response = yield call(request, 'api/auth/oAuthSignup', {
      payload: payload.oAuthInfo,
    });

    // console.log('oAuthInfo response', response);

    if (response.status === 'success') {
      const { token } = response.result;
      console.log('oAuthInfo success token', token)
      setAuthToken(token);
      yield put({
        type: ActionTypes.SESSION_SIGNUP_AUTH_CODE_SUCCESS,
        payload: { token },
      });
    }
    else {
      // console.log('oAuthInfo saga error encountered');
      yield put({
        type: ActionTypes.SESSION_SIGNUP_AUTH_CODE_FAILURE,
        payload: response.result.errors,
      });
    }
  }
  catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.SESSION_SIGNUP_AUTH_CODE_FAILURE,
      payload: [],
    });
  }
}


export default function* root() {
  yield all([
    takeLatest(ActionTypes.SESSION_SIGNUP_REQUEST, signup),
    takeLatest(ActionTypes.SESSION_LOGIN_AUTH_CODE_REQUEST, oAuthLogin),
    takeLatest(ActionTypes.SESSION_SIGNUP_AUTH_CODE_REQUEST, oAuthSignup),
    takeLatest(ActionTypes.SESSION_LOGIN_REQUEST, login),
    takeLatest(ActionTypes.SESSION_LOGOUT_REQUEST, logout),
    takeLatest(ActionTypes.SESSION_RESET_REQUEST, resetPassword),
    takeLatest(ActionTypes.SESSION_FORGOT_REQUEST, forgotPassword),
    takeLatest(ActionTypes.SESSION_REGISTERFCM_REQUEST, registerFCMToken),
  ]);
}



// WEBPACK FOOTER //
// ./scripts/sagas/session.js